//
// Autogenerated by Thrift Compiler (0.7.0-en-11139b3b5cb61e817408c6e84b0e1c258bf6c6ae)
//
// DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
//


  // Define types and services

  var Thrift = require('evernote-thrift').Thrift;
  var Types = require('./Types');


  module.exports.IncentiveRedemptionStatus = {
    'ACTIVE' : 1,
    'IN_PROGRESS' : 2,
    'REDEEMED' : 3,
    'EXPIRED' : 4
  };

  module.exports.IncentiveType = {
    'BONUS' : 1,
    'SAVINGS' : 2,
    'TRIAL' : 3
  };

  module.exports.IncentiveValidationType = {
    'SIGNATURE' : 1,
    'SILVERPOP' : 2
  };

  module.exports.IncentiveTimeUnit = {
    'DAYS' : 1,
    'WEEKS' : 2,
    'MONTHS' : 3,
    'YEARS' : 4
  };

  module.exports.IncentiveAttributeType = {
    'ELIGIBLE_SKU' : 1,
    'COUNTRY_RESTRICTION' : 2,
    'CURRENCY_RESTRICTION' : 3,
    'COMMERCE_SERVICE_RESTRICTION' : 4,
    'EMAIL_RESTRICTION' : 5,
    'LANGUAGE_RESTRICTION' : 6,
    'SKU_RESTRICTION' : 7,
    'SERVICE_LEVEL_RESTRICTION' : 8
  };

  module.exports.IncentiveEligibility = Thrift.Struct.define('IncentiveEligibility',  {
    1: { alias: 'requiredOffer', type: Thrift.Type.STRING },
    2: { alias: 'requiredOrigin', type: Thrift.Type.STRING },
    3: { alias: 'validationType', type: Thrift.Type.I32 },
    4: { alias: 'validationSecret', type: Thrift.Type.STRING },
    5: { alias: 'redemptionsAllowed', type: Thrift.Type.BYTE },
    6: { alias: 'redemptionsAllowedUnit', type: Thrift.Type.I32 },
    7: { alias: 'createdBefore', type: Thrift.Type.I64 },
    8: { alias: 'requiredCountries', type: Thrift.Type.SET, def: Thrift.Set.define(Thrift.Type.STRING) },
    9: { alias: 'requiredCurrencies', type: Thrift.Type.SET, def: Thrift.Set.define(Thrift.Type.STRING) },
    10: { alias: 'requiredCommerceServices', type: Thrift.Type.SET, def: Thrift.Set.define(Thrift.Type.STRING) },
    11: { alias: 'requiredEmailSuffixes', type: Thrift.Type.SET, def: Thrift.Set.define(Thrift.Type.STRING) },
    12: { alias: 'requiredLanguages', type: Thrift.Type.SET, def: Thrift.Set.define(Thrift.Type.STRING) },
    13: { alias: 'requiredSkus', type: Thrift.Type.SET, def: Thrift.Set.define(Thrift.Type.STRING) },
    14: { alias: 'requiredServiceLevels', type: Thrift.Type.SET, def: Thrift.Set.define(Thrift.Type.I32) }
  });

  module.exports.Incentive = Thrift.Struct.define('Incentive',  {
    1: { alias: 'id', type: Thrift.Type.I32 },
    2: { alias: 'internalName', type: Thrift.Type.STRING },
    3: { alias: 'promoCode', type: Thrift.Type.STRING },
    4: { alias: 'enabled', type: Thrift.Type.BOOL },
    5: { alias: 'startDate', type: Thrift.Type.I64 },
    6: { alias: 'endDate', type: Thrift.Type.I64 },
    7: { alias: 'incentiveType', type: Thrift.Type.I32 },
    8: { alias: 'percentSaved', type: Thrift.Type.I32 },
    9: { alias: 'incentiveTimeLength', type: Thrift.Type.BYTE },
    10: { alias: 'incentiveTimeUnit', type: Thrift.Type.I32 },
    11: { alias: 'eligibleSkuCodes', type: Thrift.Type.SET, def: Thrift.Set.define(Thrift.Type.STRING) },
    12: { alias: 'eligibilityFilters', type: Thrift.Type.STRUCT, def: module.exports.IncentiveEligibility }
  });

  module.exports.IncentiveAssociation = Thrift.Struct.define('IncentiveAssociation',  {
    1: { alias: 'id', type: Thrift.Type.I64 },
    2: { alias: 'incentiveId', type: Thrift.Type.I32 },
    3: { alias: 'userId', type: Thrift.Type.I32 },
    4: { alias: 'created', type: Thrift.Type.I64 },
    5: { alias: 'userSignature', type: Thrift.Type.STRING },
    6: { alias: 'overrideEligibility', type: Thrift.Type.BOOL },
    7: { alias: 'redemptionStatus', type: Thrift.Type.I32 },
    8: { alias: 'redemptionStatusUpdated', type: Thrift.Type.I64 },
    9: { alias: 'redemptionOrderNumber', type: Thrift.Type.STRING }
  });

